import http from './httpRequest.js'

// 超时跟进配置（粉丝超时未回复自动跟进，每个客服一份）
export function getAutoFollowUpConfig() {
  return http({
    url: '/api/v1/customer/auto_followup_config',
    method: 'get'
  })
}

export function saveAutoFollowUpConfig(data) {
  return http({
    url: '/api/v1/customer/auto_followup_config',
    method: 'post',
    data
  })
}
